<template>
<div>
    <div class="flex ">
        <el-input v-model="inputValue" class="mr-[12px] w-[200px]" placeholder="请输入文献信息" />
        <el-button @click="search">查询</el-button>
    </div>
    <div class="mt-[10px] mb-[20px] flex items-center">
        <span>关键词：</span>
        <el-tag 
            v-for="keyword in formData?.keywords" 
            :key="keyword" 
            type="primary" 
            effect="dark" 
            class="ml-[8px] cursor-pointer" 
            @click="handleKeywordClick(keyword)"
        >
            {{ keyword }}
        </el-tag>
    </div>
    <div
        ref="scrollContainer"
        v-loading="loading && list.length === 0"
        class="h-[360px] overflow-y-auto"
        @scroll="handleScroll"
    >
        <div
            v-for="(item) in list"
            :key="getUniqueKey(item)"
            class="flex justify-between border w-[100%] h-[65px] mb-[20px] p-[10px] rounded-sm"
            :class="{
                'bg-[#e3eefb]': selectedKeys.has(getUniqueKey(item)),
                'border-[#409eff]': selectedKeys.has(getUniqueKey(item))
            }"
        >
            <div class="flex flex-col flex-1 min-w-0 mr-2">
                <div class="text-[14px] font-medium truncate" :title="item.name">{{item.name}}</div>
                <div class="text-[12px] text-gray-500 truncate">
                    {{item.author}} - {{item.source}} ({{item.date}})
                </div>
            </div>
            <div class="flex items-center">
                <a :href="item.name_href" target="_blank" class="mr-[10px] text-[#409eff]">查看</a>
                <el-checkbox :model-value="selectedKeys.has(getUniqueKey(item))" label="选择" size="large" @change="(checked: boolean) => handleCheckboxChange(item, checked)" />
            </div>
        </div>
        <p v-if="loading && list.length > 0" class="text-center text-gray-500">加载中...</p>
        <p v-if="!hasMore && list.length > 0" class="text-center text-gray-500">没有更多了</p>
    </div>
    <!-- <MyTable ref="tableRef" :isPaginated="true" :getListApi="getListApi"> -->
    <!-- <template #body="data"> -->
        <!-- <CouponItems
        v-for="item in data.data || []"
        :key="item.id"
        :item="item"
        :checkedId="checkedValue?.id"
        @click="() => handleCoupon(item)"
        /> -->
        <!-- <div v-for="item in data.data || []" :key="item">{{item}}</div> -->
    <!-- </template> -->
    <!-- </MyTable> -->
</div>
</template>
<script setup lang="ts">
import {ref, onMounted, onUnmounted, computed} from 'vue';
// import MyTable from '@/components/Table/DataTable.vue';
import {post} from '@/api/api'
import { Literature } from './Table/interfaces';
// const tableRef = ref(); // 获取table组件实例
import { defineEmits } from 'vue';
import { defineProps } from 'vue';
const emit = defineEmits(['update:modelValue'])

interface Props {
modelValue: any[];
formData?: {
    keywords?: string[];
    [key: string]: any;
};
isBack?: boolean; // 添加标记，用于判断是否是上一步
}
const props = defineProps<Props>();

const getUniqueKey = (item: Literature) => `${item.name}-${item.source}`;
const selectedKeys = computed(() => new Set(props.modelValue.map(getUniqueKey)));

const inputValue = ref(props.formData?.keywords?.join(' + ') || '');
const pageNum = ref(1);
const hasMore = ref(true);
const loading = ref(false);
const scrollContainer = ref<HTMLDivElement | null>(null);

const list = ref<Literature[]>([]);

const handleCheckboxChange = (item: Literature, isChecked: boolean) => {
    const newModelValue = [...props.modelValue];
    const key = getUniqueKey(item);
    const itemIndex = newModelValue.findIndex(i => getUniqueKey(i) === key);

    if (isChecked) {
        if (itemIndex === -1) {
            newModelValue.push(item);
        }
    } else {
        if (itemIndex > -1) {
            newModelValue.splice(itemIndex, 1);
        }
    }
    emit('update:modelValue', newModelValue);
}

const handleKeywordClick = (keyword: string) => {
  inputValue.value = keyword;
  search();
};

const search = () => {
    pageNum.value = 1;
    hasMore.value = true;
    list.value = [];
    getListApi();
}

const getListApi = async () => {
    if (loading.value || !hasMore.value) return;
    
    // 如果是上一步，直接返回
    if (props.isBack && pageNum.value === 1) {
        return;
    }
    
    loading.value = true;
    try {
        const response = await post('/aiGenerate/literature', {
            "pageNum": pageNum.value,
            "pageSize": 10,
            "keywords": inputValue.value
        });
        console.log('API response:', response);
        
        // 获取实际的响应数据
        const responseData = response.data;
        console.log('Response data:', responseData);
        
        if (responseData && responseData.code === 0 && Array.isArray(responseData.data)) {
            console.log('Setting list with data:', responseData.data);
            const newItems = responseData.data;
            
            if (pageNum.value === 1) {
                list.value = newItems;
            } else {
                list.value = [...list.value, ...newItems];
            }

            if (newItems.length < 10) {
                hasMore.value = false;
            } else {
                pageNum.value++;
            }
            
            console.log('Updated list:', list.value);
        } else {
            console.error('Invalid response format:', responseData);
            hasMore.value = false;
        }
    } catch (error) {
        console.error('请求失败:', error);
        hasMore.value = false;
    } finally {
        loading.value = false;
    }
};

const handleScroll = () => {
    if (!scrollContainer.value) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
    if (clientHeight + scrollTop >= scrollHeight - 20) {
        getListApi();
    }
}

// 初始化时调用一次
onMounted(() => {
    console.log('Component mounted, calling getListApi');
    getListApi();
});

onUnmounted(() => {
    if (scrollContainer.value) {
        scrollContainer.value.removeEventListener('scroll', handleScroll)
    }
})
</script>